import { Seo } from "@/components/Seo";

const H2 = ({ children }) => (
  <h2 className="mt-10 text-xl font-bold text-ink">{children}</h2>
);

export default function MentionsLegales() {
  return (
    <div className="bg-white pb-24 pt-32" data-testid="mentions-legales-page">
      <Seo
        title="Mentions légales — Syndicappli360"
        description="Mentions légales du site Syndicappli360 : éditeur, hébergement et propriété intellectuelle."
        path="/mentions-legales"
      />
      <div className="mx-auto max-w-3xl px-6 lg:px-10">
        <span className="inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-electric">
          <span className="h-px w-10 bg-electric" />
          Informations légales
        </span>
        <h1 className="mt-5 text-4xl font-bold tracking-normal leading-[1.15] text-ink md:text-5xl">
          Mentions légales
        </h1>

        <H2>Éditeur du site</H2>
        <p className="mt-3 text-sm leading-relaxed text-ink/70">
          Le site syndicappli360.com est édité par <strong>Syndicappli</strong>,
          6, rue Léonard De Vinci, CS 20119, 53001 Laval, France.
        </p>
        <p className="mt-3 text-sm leading-relaxed text-ink/70">
          Téléphone : +33 7 55 60 85 50 — Email : contact@syndicappli.fr
        </p>
        <p className="mt-3 text-sm leading-relaxed text-ink/50">
          [À compléter par l'éditeur : forme juridique, numéro d'immatriculation
          (RCS), capital social et nom du directeur de la publication.]
        </p>

        <H2>Hébergement</H2>
        <p className="mt-3 text-sm leading-relaxed text-ink/70">
          Le site est hébergé sur la plateforme cloud Emergent
          (emergentagent.com). La connexion au site est chiffrée (HTTPS).
        </p>

        <H2>Propriété intellectuelle</H2>
        <p className="mt-3 text-sm leading-relaxed text-ink/70">
          L'ensemble des contenus du site (textes, visuels, logos, marque
          Syndicappli) est protégé par le droit de la propriété intellectuelle.
          Toute reproduction, totale ou partielle, sans autorisation écrite
          préalable de l'éditeur est interdite.
        </p>

        <H2>Données personnelles</H2>
        <p className="mt-3 text-sm leading-relaxed text-ink/70">
          Pour connaître comment vos données sont collectées et traitées,
          consultez notre{" "}
          <a href="/politique-de-confidentialite" className="font-semibold text-electric underline" data-testid="mentions-privacy-link">
            politique de confidentialité
          </a>
          .
        </p>
      </div>
    </div>
  );
}
